import type { FC } from 'react'
import type { CardMeta } from '../dashboard/types'
import CardInfoButton from './CardInfoButton'

type InsightsPanelProps = {
  insights: { icon: string; color: string; text: string }[]
  onViewAll: () => void
}

const meta: CardMeta = {
  description: 'Rule-based summaries of the loaded voyage, defect and Draft-report records.',
  endpoint: 'Derived from aggregated voyage, defect, and report data',
  logic: 'Summarizes loaded counts only. Draft age is not a deadline; no improvement or congestion trend is invented when data is absent.',
}

const InsightsPanel: FC<InsightsPanelProps> = ({ insights, onViewAll }) => {
  const hasData = insights.length > 0

  return (
    <div className='flex flex-col flex-1'>
      <div className='card flex-1' style={{ borderRadius: '16px' }}>
        <div className='card-body'>
          <div className='d-flex align-items-center gap-2 mb-3'>
            <h6 className='fw-bold text-dark mb-0' style={{ fontSize: '13px' }}>Operations Insights</h6>
            <span className='ms-auto d-flex align-items-center gap-2'>
              <CardInfoButton meta={meta} />
              <a href='#' className='fw-bold' style={{ fontSize: '10px' }} onClick={(e) => { e.preventDefault(); onViewAll(); }}>View all</a>
            </span>
          </div>
          <div className='d-flex flex-column gap-2'>
            {hasData ? (
              <>{insights.map((insight, i) => <InsightCard key={i} {...insight} />)}</>
            ) : (
              <div className='text-center text-muted py-4' style={{ fontSize: '11px' }}>
                <div className='mb-1'>No insights available</div>
                <div style={{ fontSize: '10px' }}>Data-driven insights will appear here</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const InsightCard: FC<{ icon: string; color: string; text: string }> = ({ icon, color, text }) => {
  const iconMap: Record<string, string> = {
    'trending-up': '/media/icons/duotune/general/gen001.svg',
    'alert-circle': '/media/icons/duotune/abstract/abs042.svg',
    fuel: '/media/icons/duotune/general/gen034.svg',
    'trending-down': '/media/icons/duotune/general/gen002.svg',
    clock: '/media/icons/duotune/general/gen018.svg',
  }
  const tailwindColor: Record<string, string> = {
    success: '#10B981',
    danger: '#EF4444',
    warning: '#F59E0B',
    orange: '#F97316',
    primary: '#3B82F6',
  }
  return (
    <div className='d-flex align-items-start gap-2 p-2 rounded border' style={{ borderColor: '#eee' }}>
      <div className='rounded d-flex align-items-center justify-content-center flex-shrink-0' style={{ width: '28px', height: '28px', backgroundColor: `${tailwindColor[color] || '#3B82F6'}20` }}>
        <img src={iconMap[icon] || iconMap['trending-up']} alt='' className='svg-icon-2' style={{ filter: 'brightness(0) saturate(100%)' }} />
      </div>
      <div className='flex-1'>
        <div className='text-dark' style={{ fontSize: '10px', lineHeight: '1.4' }}>{text}</div>
      </div>
    </div>
  )
}

export default InsightsPanel
